import { r as registerInstance, c as createEvent, h, g as getElement } from './index-d4808923.js';
import { R as ResizeObserver } from './ResizeObserver-24585425.js';
import { g as global$1, b as bem } from './index.esm-7182addc.js';
import { c as cloneDeep } from './index-167f81e8.js';
import { c as createPopper } from './popper-1604923e.js';
import { g as getTextColor } from './getTextColor-1c68221e.js';
import { l as isValidDate, s as setTimeWithFallback, c as getTimeZoneOffset, e as decimalToHHMM } from './date-utils-73271ab4.js';

const gravitySelectCss = ".gravity-select{--gravity-dropdown-inner-prefix-size:18px;display:flex;flex-direction:column;position:relative}.gravity-select__dropdown{background-color:#FFFFFF;border:1px solid rgba(0, 15, 30, 0.2);border-radius:6px;box-shadow:0px 8px 12px 0px rgba(0, 15, 30, 0.0392156863), 0px 2px 4px 0px rgba(0, 15, 30, 0.0196078431);box-sizing:border-box;display:flex;flex-direction:column;opacity:0;overflow:hidden;pointer-events:none;position:absolute;text-align:left;transition:opacity 150ms cubic-bezier(0.32, 0, 0.32, 1);visibility:hidden;z-index:1000}.gravity-select--open .gravity-select__dropdown{opacity:1;pointer-events:auto;transform:scale(1, 1);visibility:visible}.gravity-select__clear-button{align-items:center;background:none;border:0;border-radius:9999px;cursor:pointer;display:flex;justify-content:center;margin-left:6px;padding:0}.gravity-select__clear-button__icon{background:rgba(0, 15, 30, 0.1);border-radius:9999px}.gravity-select__clear-button__icon:focus{outline:none}.gravity-select__clear-button__icon:hover{background-color:rgba(0, 15, 30, 0.2)}.gravity-select__input{align-items:center;background-color:#FFFFFF;border-bottom:var(--gravity-select-border-bottom, 1px solid rgba(0, 15, 30, 0.2));border-left:var(--gravity-select-border-left, 1px solid rgba(0, 15, 30, 0.2));border-radius:var(--gravity-select-border-radius, 6px);border-right:var(--gravity-select-border-right, 1px solid rgba(0, 15, 30, 0.2));border-style:solid;border-top:var(--gravity-select-border-top, 1px solid rgba(0, 15, 30, 0.2));border-width:1px;box-sizing:border-box;cursor:pointer;display:flex;justify-content:space-between;min-height:40px;padding:7px 12px;position:relative}.gravity-select__input:focus:not(:focus-visible){outline:none}.gravity-select__input:focus-visible{outline:2px solid #1B6AEE;outline-offset:2px}.gravity-select__input:hover,.gravity-select__input:focus{border-color:rgba(0, 15, 30, 0.45)}.gravity-select--open .gravity-select__input{box-shadow:0px 8px 12px 0px rgba(0, 15, 30, 0.0392156863), 0px 2px 4px 0px rgba(0, 15, 30, 0.0196078431)}.gravity-select--highlighted .gravity-select__input{background-color:#F4F8FE}.gravity-select--highlighted .gravity-select__input:hover,.gravity-select--highlighted .gravity-select__input:focus{background-color:#F4F8FE;outline:none}.gravity-select__input__value{align-items:center;display:flex;overflow:hidden}.gravity-select--multi-grow .gravity-select__input__value{display:flex;flex-wrap:wrap;gap:4px;overflow:auto}.gravity-select__input__value__text{display:inline-block;text-overflow:ellipsis;user-select:none;white-space:nowrap}.gravity-select__input__value__tag{cursor:auto;display:inline-block;margin-inline-end:4px}.gravity-select--multi-grow .gravity-select__input__value__tag{margin-inline-end:0}.gravity-select__input .gravity-select__chevron-icon{margin-inline-start:6px;transition:all 150ms cubic-bezier(0.32, 0, 0.32, 1)}.gravity-select__input__operators{align-items:center;display:flex;justify-content:flex-end;margin-inline-start:auto}.gravity-select--multi-grow .gravity-select__input__operators{align-self:center}.gravity-select--open .gravity-select__input__operators .gravity-select__chevron-icon{transform:rotate(-180deg)}.gravity-select--multi .gravity-select__input__value{overflow-x:auto;overflow-y:hidden}.gravity-select--multi .gravity-select__input__value::-webkit-scrollbar{display:none}.gravity-select--size-small .gravity-select__input{border-radius:var(--gravity-select-border-radius, 4px);min-height:32px;padding:5px 8px}.gravity-select--size-small .gravity-select__clear-button{margin-left:4px}.gravity-select--size-small .gravity-select__chevron-icon{margin-inline-start:4px}.gravity-select--disabled:not(.gravity-select--highlighted) .gravity-select__input{background-color:rgba(0, 15, 30, 0.05)}.gravity-select--disabled .gravity-select__input{border-color:transparent;cursor:default;pointer-events:none}.gravity-select--invalid .label-asterisk,.gravity-select--required .label-asterisk{color:#DB0A40}.gravity-select--invalid .gravity-select__input,.gravity-select--required .gravity-select__input{border-color:#DB0A40}";
const GravitySelectStyle0 = gravitySelectCss;

const generateClassNames$1 = bem('gravity-select');
const GravitySelect = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.isOpen = createEvent(this, "isOpen", 1);
        this.optionsSelected = createEvent(this, "optionsSelected", 5);
        this.scrollEnd = createEvent(this, "scrollEnd", 5);
        this.searchChange = createEvent(this, "searchChange", 5);
        this.tagClicked = createEvent(this, "tagClicked", 7);
        this.popperInstance = undefined;
        this.resizeObserver = new ResizeObserver(() => {
            this.setDropdownWidth();
        });
        this.clearable = true;
        this.clickableTags = false;
        this.disabled = false;
        this.highlighted = false;
        this.infoBottom = false;
        this.infoPosition = 'top';
        this.infoText = '';
        this.infoWidth = undefined;
        this.inline = false;
        this.inlineLabelWidth = '33%';
        this.invalid = false;
        this.label = '';
        this.maxHeight = 420;
        this.multi = false;
        this.multiGrow = false;
        this.options = [];
        this.placeholder = '';
        this.positionStrategy = 'absolute';
        this.queryType = false;
        this.required = false;
        this.searchBusy = false;
        this.searchPlaceholder = 'Search';
        this.selected = [];
        this.size = 'medium';
        this.validationMessage = '';
        this.open = false;
        this.selectedOptions = [];
        this.showClearButton = false;
        this.valueMissing = false;
    }
    handleOptionsChange() {
        this.setSelectedOptions();
        this.setDropdownWidth();
    }
    handleSelectChange() {
        this.setSelectedOptions();
        this.validate();
        this.updateShowClearButton();
    }
    requiredChangeHandler() {
        if (!this.required && this.valueMissing) {
            this.valueMissing = false;
        }
    }
    async toggleOpen() {
        if ((this.options.length == 0 && this.queryType === 'filter') || this.disabled) {
            return;
        }
        if (!this.popperInstance) {
            return;
        }
        this.open = !this.open;
        if (!this.open) {
            this.popperInstance.forceUpdate();
            await this.popperInstance.update();
        }
        this.isOpen.emit(this.open);
    }
    clearSelection($event) {
        // prevent opening dropdown
        $event.stopPropagation();
        this.selected = this.selected.filter((id) => {
            const option = this.options
                .flatMap((option) => (option.options ? [option, ...option.options] : option))
                .find((option) => option.id === id);
            return option === null || option === void 0 ? void 0 : option.disabled;
        });
        if (this.queryType) {
            this.dropdownInner.shadowRoot.querySelector('gravity-search').reset();
        }
        this.optionsSelected.emit(this.selected);
    }
    handleSelection(event) {
        if (this.multi) {
            this.selected = [...event.detail];
        }
        else {
            this.selected = [event.detail[0]];
        }
        this.optionsSelected.emit(this.selected);
    }
    hide() {
        this.open = false;
        this.isOpen.emit(this.open);
        this.validate();
    }
    validate() {
        if (this.required && this.selected.length == 0) {
            this.valueMissing = true;
        }
        else if (this.valueMissing) {
            this.valueMissing = false;
        }
    }
    removeOption(id) {
        this.selected = [...this.selected.filter((currentId) => currentId !== id)];
        this.optionsSelected.emit(this.selected);
    }
    setSelectedOptions() {
        var _a;
        if (!this.selected) {
            return;
        }
        // remove elements that got unselected
        this.selectedOptions = this.selectedOptions.filter((option) => !!this.selected.find((selectedId) => selectedId == option.id));
        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.length) {
            // save elements from the options array
            let newSelectedOptions = this.selected
                .map((id) => {
                return cloneDeep(this.options)
                    .map((option) => (option.options ? [option, ...option.options] : option))
                    .flat()
                    .find((option) => option.id == id);
            })
                .filter((option) => option !== undefined);
            // if it is a single select just replace the array
            if (!this.multi && newSelectedOptions.length) {
                this.selectedOptions = newSelectedOptions;
            }
            else {
                // remove duplicates
                newSelectedOptions = newSelectedOptions.filter((option) => !this.selectedOptions.find((element) => element.id == option.id));
                this.selectedOptions = [...this.selectedOptions, ...newSelectedOptions];
            }
        }
    }
    setDropdownWidth() {
        var _a;
        if (this.dropdown) {
            this.dropdown.style.width = this.input.getBoundingClientRect().width + 'px';
            (_a = this.popperInstance) === null || _a === void 0 ? void 0 : _a.update();
        }
    }
    createPopUp() {
        this.popperInstance = createPopper(this.input, this.dropdown, {
            strategy: this.positionStrategy,
            placement: 'bottom',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, this.size === 'small' ? 4 : 8],
                    },
                },
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: ['top'],
                    },
                },
            ],
        });
    }
    composeTitle() {
        if (this.selectedOptions[0].meta) {
            return `${this.selectedOptions[0].label} • ${this.selectedOptions[0].meta}`;
        }
        return this.selectedOptions[0].label;
    }
    updateShowClearButton() {
        this.showClearButton =
            !this.disabled &&
                this.clearable &&
                this.selected.some((id) => {
                    const option = this.options
                        .flatMap((option) => (option.options ? [option, ...option.options] : option))
                        .find((option) => option.id === id);
                    return !(option === null || option === void 0 ? void 0 : option.disabled);
                });
    }
    renderValue() {
        if (this.selectedOptions.length > 0) {
            if (this.multi) {
                return (h("div", { class: generateClassNames$1('input__value') }, this.selectedOptions.map((option) => (h("gravity-tag", { id: option.id, class: generateClassNames$1('input__value__tag'), color: "dark", clickable: this.clickableTags, removable: !this.disabled && !option.disabled, onTagRemoved: () => this.removeOption(option.id), onClick: (event) => event.stopPropagation(), size: this.size === 'small' ? 'small' : 'large' }, option.label)))));
            }
            else {
                return (h("div", { title: this.composeTitle(), class: generateClassNames$1('input__value') }, h("gravity-text", { class: generateClassNames$1('input__value__text'), color: getTextColor(this.disabled, this.highlighted), size: this.size === 'small' ? 'x-small' : 'small', clamp: 1 }, this.selectedOptions[0].label)));
            }
        }
        const placeholderString = this.placeholder
            ? this.placeholder
            : this.multi
                ? 'Select one or more options...'
                : 'Select an option...';
        return (h("div", { class: generateClassNames$1('input__value') }, h("gravity-text", { class: generateClassNames$1('input__value__text'), color: "dark-muted", size: this.size === 'small' ? 'x-small' : 'small' }, placeholderString)));
    }
    renderClearButton() {
        if (!this.showClearButton) {
            return;
        }
        return (h("button", { class: generateClassNames$1('clear-button'), tabindex: -1, onClick: ($event) => {
                this.clearSelection($event);
            } }, h("gravity-icon", { class: generateClassNames$1('clear-button__icon'), name: "close", color: "dark", size: "xxx-small" })));
    }
    connectedCallback() {
        if (this.input) {
            this.createPopUp();
            this.resizeObserver.observe(this.input);
        }
    }
    componentWillLoad() {
        this.setSelectedOptions();
        if (this.multiGrow) {
            this.multi = true;
        }
    }
    componentDidLoad() {
        this.valueMissing = false;
        this.input.onmouseenter = () => {
            if (this.disabled) {
                return;
            }
            this.updateShowClearButton();
        };
        this.input.onmouseleave = () => {
            if (global$1.document.activeElement !== this.element) {
                this.showClearButton = false;
            }
        };
        this.input.onkeydown = (event) => {
            if (this.element.shadowRoot.activeElement != this.input) {
                return;
            }
            const { key } = event;
            if ((key == 'Enter' || key == ' ' || key == 'ArrowDown' || key == 'ArrowUp') && !this.open) {
                this.toggleOpen();
            }
        };
        this.element.onblur = () => {
            this.validate();
            this.hide();
        };
        this.resizeObserver.observe(this.input);
        this.createPopUp();
    }
    componentWillRender() {
        var _a;
        (_a = this.popperInstance) === null || _a === void 0 ? void 0 : _a.update();
    }
    disconnectedCallback() {
        var _a;
        (_a = this.popperInstance) === null || _a === void 0 ? void 0 : _a.destroy();
        this.resizeObserver.disconnect();
    }
    render() {
        var _a;
        const disabled = (((_a = this.options) === null || _a === void 0 ? void 0 : _a.length) == 0 && this.queryType === 'filter') || this.disabled;
        return [
            h("gravity-form-field", { key: '982e6025e5016630487e07522389d5496e24b051', label: this.label, highlighted: this.highlighted, inline: this.inline, inlineLabelWidth: this.inlineLabelWidth, infoBottom: this.infoBottom, infoPosition: this.infoPosition, infoText: this.infoText, infoWidth: this.infoWidth, required: this.required, size: this.size, disabled: disabled, invalid: !!this.validationMessage || this.valueMissing, validationMessage: this.valueMissing ? 'This field is required' : this.validationMessage }, h("div", { key: '641b008770ddbb614f4ba912d5bc1e25cfd0d02a', class: generateClassNames$1({
                    disabled,
                    'inline': this.inline,
                    'multi': this.multi,
                    'required': this.valueMissing,
                    'multi-grow': this.multiGrow,
                    'open': this.open,
                    'invalid': this.invalid || !!this.validationMessage,
                    'size': this.size,
                    'highlighted': this.highlighted,
                }) }, h("div", { key: '0d19557ae48325b0d43a9492ed8062743c1d93e0', class: generateClassNames$1('input'), ref: (el) => (this.input = el), onClick: () => this.toggleOpen(), tabIndex: disabled ? -1 : 0 }, this.renderValue(), h("div", { key: '78cf77ac9ea4640dfd469c14e98ed622f517219d', class: generateClassNames$1('input__operators') }, this.renderClearButton()), h("gravity-icon", { key: 'f63f93732fa6d37ecf3671dc3dffb3b56619ed33', name: "arrow-down-outline", color: this.disabled ? 'dark-muted' : 'dark', size: this.size === 'small' ? 'xxx-small' : 'xx-small', class: generateClassNames$1('chevron-icon') })), h("div", { key: '7b0fa356e4f6f1ca2c071bfb2ea5f976839bb927', class: generateClassNames$1('dropdown'), ref: (el) => (this.dropdown = el) }, h("gravity-dropdown-inner", { key: 'd19450820e747943f168334f36c3981d3d065187', isRoot: true, options: this.options, "selection-behavior": this.multi ? 'multi' : 'single', "max-height": this.maxHeight, selected: this.selected, "query-type": this.queryType, dropdown: this.element, visible: this.open, keyboardNavigation: this.open, ref: (el) => (this.dropdownInner = el), onDropdownOptionSelected: (event) => this.handleSelection(event), onSearchChange: (event) => this.searchChange.emit(event.detail), onScrollEnd: () => this.scrollEnd.emit(), onHide: () => this.hide(), size: this.size === 'small' ? 'small' : 'medium', searchPlaceholder: this.searchPlaceholder, searchBusy: this.searchBusy, triggerElement: this.input, width: "anchor" })))),
        ];
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "options": ["handleOptionsChange"],
        "selected": ["handleSelectChange"],
        "required": ["requiredChangeHandler"]
    }; }
};
GravitySelect.style = GravitySelectStyle0;

const gravityTimeInputCss = ".gravity-time-input{font-feature-settings:\"liga\" on;font-feature-settings:\"liga\" on;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;display:flex;flex-direction:column;gap:4px}.gravity-time-input *{box-sizing:border-box}.gravity-time-input__label{display:inline-block}.gravity-time-input__block{align-items:flex-start;display:flex;flex-direction:row;gap:4px;max-width:300px}.gravity-time-input__inner{flex:1 1 50%;position:relative}.gravity-time-input__input{background-color:#FFFFFF;border:1px solid rgba(0, 15, 30, 0.2);border-radius:4px;color:#000F1E;font-family:\"Bull\", Helvetica, sans-serif;font-size:14px;font-weight:400;height:32px;line-height:1.333333;padding:4px 24px 4px 8px;text-align:left;width:100%}.gravity-time-input__input:hover{border-color:rgba(0, 15, 30, 0.45)}.gravity-time-input__input:focus-visible{outline:2px solid #1B6AEE;outline-offset:2px}.gravity-time-input__input::-webkit-datetime-edit-fields-wrapper{padding:unset;text-align:center;width:56px}.gravity-time-input__input::-webkit-datetime-edit-minute-field,.gravity-time-input__input::-webkit-datetime-edit-hour-field{display:inline-block;height:16px;padding:unset;width:22px}.gravity-time-input__input::-webkit-datetime-edit-text{display:inline-block;font-weight:500;width:12px}.gravity-time-input__input::-webkit-inner-spin-button,.gravity-time-input__input::-webkit-clear-button,.gravity-time-input__input::-webkit-datetime-edit-ampm-field,.gravity-time-input__input::-webkit-calendar-picker-indicator{appearance:none;background:none;display:none;margin:0}.gravity-time-input__buttons{display:inline-flex;flex-direction:column;padding:0;position:absolute;right:8px;top:4px;vertical-align:super}.gravity-time-input__buttons__button{--gravity-base-icon-size:12px;align-items:center;background:none;border:0;cursor:pointer;display:inline-flex;justify-content:center;padding:0}.gravity-time-input__buttons__button:focus-visible{border-radius:2px;outline:2px solid #1B6AEE;outline-offset:1px}.gravity-time-input__ampm-toggle{align-items:flex-start;background-color:#FFFFFF;border-radius:4px;display:flex;flex:1 1 50%;flex-direction:row;outline:1px solid rgba(0, 15, 30, 0.2);padding:4px}.gravity-time-input__ampm-toggle:hover{outline-color:rgba(0, 15, 30, 0.45)}.gravity-time-input__ampm-toggle__input{height:0;opacity:0;position:absolute;width:0}.gravity-time-input__ampm-toggle__label{border-radius:2px;color:rgba(0, 15, 30, 0.6);cursor:pointer;flex:1 0 50%;font-family:\"Bull\", Helvetica, sans-serif;font-size:12px;font-weight:500;line-height:1.333333;padding:4px 8px;text-align:center;width:50%}.gravity-time-input__ampm-toggle__input:checked+.gravity-time-input__ampm-toggle__label{background-color:#00162B;color:#FFFFFF}.gravity-time-input__ampm-toggle__input:focus-visible+.gravity-time-input__ampm-toggle__label{border-radius:2px;outline:2px solid #1B6AEE;outline-offset:2px}";
const GravityTimeInputStyle0 = gravityTimeInputCss;

const generateClassNames = bem('gravity-time-input');
const GravityTimeInput = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.timeChanged = createEvent(this, "timeChanged", 5);
        this.label = undefined;
        this.maxDate = undefined;
        this.minDate = undefined;
        this.time = undefined;
        this.timeZone = undefined;
    }
    onTimeChange(value) {
        if (!isValidDate(value)) {
            this.time = new Date();
        }
        this.validateTime();
    }
    onTimeZoneChange() {
        this.validateTime();
    }
    increment() {
        const newTime = isValidDate(this.time) ? this.time : setTimeWithFallback();
        newTime.setUTCMinutes(newTime.getUTCMinutes() % 15 != 0 ? Math.ceil(newTime.getUTCMinutes() / 15) * 15 : newTime.getUTCMinutes() + 15);
        this.updateTime(newTime);
    }
    decrement() {
        const newTime = isValidDate(this.time) ? this.time : setTimeWithFallback();
        newTime.setUTCMinutes(Math.ceil(newTime.getUTCMinutes() / 15) * 15 - 15);
        this.updateTime(newTime);
    }
    updateTime(time) {
        let newTime;
        if (!isValidDate(time)) {
            newTime = setTimeWithFallback();
        }
        newTime = new Date(Date.UTC(time.getUTCFullYear(), time.getUTCMonth(), time.getUTCDate(), time.getUTCHours(), time.getUTCMinutes(), 0, 0));
        this.time = newTime;
        this.validateTime();
        this.timeChanged.emit(this.time);
    }
    getTime() {
        if (!isValidDate(this.time)) {
            return '';
        }
        return this.time
            .toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: this.timeZone,
        })
            .split(' ')[0];
    }
    getAMPM() {
        if (!isValidDate(this.time)) {
            return 'AM';
        }
        return this.time
            .toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: this.timeZone,
        })
            .split(' ')[1];
    }
    setAMPM(value) {
        if (this.getAMPM() == value || !isValidDate(this.time)) {
            return;
        }
        const newTime = new Date(Date.UTC(this.time.getUTCFullYear(), this.time.getUTCMonth(), this.time.getUTCDate(), this.time.getUTCHours(), this.time.getUTCMinutes()));
        const localHour = parseInt(this.time.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
            timeZone: this.timeZone,
        }));
        if (value == 'AM' && localHour >= 12) {
            newTime.setUTCHours(newTime.getUTCHours() - 12);
        }
        else if (value == 'PM') {
            newTime.setUTCHours(newTime.getUTCHours() + 12);
        }
        this.updateTime(newTime);
    }
    handleInputChange(event) {
        var _a;
        const [hours, minutes] = event.currentTarget.value
            .split(':')
            .map((val) => Number(val));
        let today = new Date();
        if (!isValidDate(this.time)) {
            today = setTimeWithFallback(hours, minutes);
        }
        const time = (_a = this.time) !== null && _a !== void 0 ? _a : today;
        const [month, day, year] = time
            .toLocaleDateString('en-US', { timeZone: this.timeZone, year: 'numeric', month: '2-digit', day: '2-digit' })
            .split('/');
        const timeZoneOffset = getTimeZoneOffset(this.timeZone, time);
        // init date with local midnight time
        const newTime = new Date(`${year}-${month}-${day}T00:00:00${decimalToHHMM(timeZoneOffset)}`);
        let normalizedHours = hours;
        if (time && this.getAMPM() == 'PM' && hours != 12) {
            normalizedHours += 12;
        }
        if (time && this.getAMPM() == 'AM' && hours == 12) {
            normalizedHours -= 12;
        }
        newTime.setUTCHours(newTime.getUTCHours() + normalizedHours);
        newTime.setUTCMinutes(minutes);
        this.updateTime(newTime);
    }
    validateTime() {
        if (!isValidDate(this.time)) {
            return;
        }
        const minDate = new Date(this.minDate);
        const maxDate = new Date(this.maxDate);
        if (this.time < minDate) {
            this.time.setHours(minDate.getHours());
            this.time.setMinutes(minDate.getMinutes());
        }
        else if (this.time > maxDate) {
            this.time.setHours(maxDate.getHours());
            this.time.setMinutes(maxDate.getMinutes());
        }
    }
    render() {
        return (h("div", { key: '943458b7148f4b51364a3c82bd616adfb833c24d', class: generateClassNames() }, this.label && (h("label", { key: '0650c138d845bc3833e0e67dc1b938827c7a0e6d', class: generateClassNames('label') }, h("gravity-text", { key: 'c2aded42e7f193a0f3930ae40c31c494c432bd30', weight: "medium", size: "xx-small", color: "dark-subtle" }, this.label))), h("div", { key: 'e0d73f961c9e54b90b7c435db579d3ec100b99fc', class: generateClassNames('block') }, h("div", { key: '8c85248b96719faf054665d8f5d617a415ac751e', class: generateClassNames('inner') }, h("input", { key: '301b7ba943a773373cdf774b9b9876a07f7eef14', class: generateClassNames('input'), readOnly: !!(this.minDate || this.maxDate), type: "time", value: this.getTime(), onBlur: (event) => this.handleInputChange(event) }), h("div", { key: '6cd73b5a3bdc806cf76fa19d8966a5f818c96c82', class: generateClassNames('buttons') }, h("button", { key: 'cbb956005f427aa8eda24dd355226a1c31f6303b', type: "button", "aria-label": "Increment time", class: generateClassNames('buttons__button'), onClick: () => this.increment() }, h("gravity-icon", { key: '1b54efd1a7d870d665bbfb4453a613b7cf2a3fbe', name: "arrow-up", size: "tiny" })), h("button", { key: '238ab544a852fa21f10a871c1383c9b5781d54c9', type: "button", "aria-label": "Decrement time", class: generateClassNames('buttons__button'), onClick: () => this.decrement() }, h("gravity-icon", { key: '826f9eb46bf19192f22bd50065d08045677f30df', name: "arrow-down", size: "tiny" })))), h("div", { key: 'fc26600ee8bea0563155cf6b70a1f62a8f5d638b', class: generateClassNames('ampm-toggle') }, h("input", { key: '3bd1a6cfe4ccbcfa09d5d4fbd56073dc197fc813', type: "radio", id: "am", value: "am", name: "ampm", class: generateClassNames('ampm-toggle__input'), checked: this.getAMPM() == 'AM', onClick: () => this.setAMPM('AM') }), h("label", { key: '7f5eeaebede18519b4cbedfa3e7f02d2836215de', class: generateClassNames('ampm-toggle__label'), htmlFor: "am" }, "AM"), h("input", { key: '7068c7895f672fb08d2377a80e047ca45855be2a', type: "radio", id: "pm", value: "pm", name: "ampm", class: generateClassNames('ampm-toggle__input'), checked: this.getAMPM() == 'PM', onClick: () => this.setAMPM('PM') }), h("label", { key: '8f70a4e33e23e49f9208406dc3278b17ec9279c3', class: generateClassNames('ampm-toggle__label'), htmlFor: "pm" }, "PM")))));
    }
    static get watchers() { return {
        "time": ["onTimeChange"],
        "timeZone": ["onTimeZoneChange"]
    }; }
};
GravityTimeInput.style = GravityTimeInputStyle0;

export { GravitySelect as gravity_select, GravityTimeInput as gravity_time_input };

//# sourceMappingURL=gravity-select_2.entry.js.map